'use client';

import Script from 'next/script';
import { generateWebsiteJsonLd } from '@fe-news/utils/metadata';

type JsonLdScriptProps = {
  metadata: SeoMetadata;
  type: 'WebSite' | 'WebPage' | 'CollectionPage' | 'NewsArticle';
};

const JsonLdScript = ({ metadata, type }: JsonLdScriptProps) => {
  return (
    <Script
      type='application/ld+json'
      strategy='afterInteractive'
      id={type === 'WebSite' ? `json-ld-${type}` : `json-ld-${type}-${metadata.title}`}
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(generateWebsiteJsonLd({ metadata, type }))
      }}
    />
  );
};

export default JsonLdScript;
